import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { UserContext } from '../../context/User';
import { useLocation, useHistory } from "react-router-dom";
import { contractingOfficerGet } from '../../api';
import Loading from '../Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';
import SinglePageItemText from '../SinglePageItemTypes/SinglePageItemText';
import SinglePageItemArray from '../SinglePageItemTypes/SinglePageItemArray';
import SinglePageItemBool from '../SinglePageItemTypes/SinglePageItemBool';

const ContractingOfficerSingle = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const id = query.get("id");
  const [officerData, setOfficerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  useEffect(() => {
    if (id) {
      setLoading(true);
      contractingOfficerGet({id})
        .then(response => {
          setOfficerData(response.data);
          setLoading(false);
        })
        .catch(error => {
          handleDefaultStatusCodes(error.response.status);
          setLoading(false);
        })
    }
  }, [])

  return (
    <section className="section-spaces">
       <Container>
        <Row>
          <Col>
            <div className="single-page-wrap">
              <h3>{officerData.name}</h3>
              <Link
                to={`/specific-message?id=${officerData.user_id}`}
                className="btnSizes filledBtn link my-2"
              >
                Contact
              </Link>
              <SinglePageItemText 
                title="Email"
                value={officerData.email}
              />
              <SinglePageItemText 
                title="Phone Number"
                value={officerData.phone1}
              />
              <SinglePageItemText 
                title="Fax"
                value={officerData.fax}
              />
              <SinglePageItemText 
                title="Secondary Phone Number"
                value={officerData.phone2}
              />
              <SinglePageItemText 
                title="City"
                value={officerData.city}
              />
              <SinglePageItemText 
                title="Installation"
                value={officerData.installation}
              />
              <SinglePageItemText 
                title="County"
                value={officerData.county}
              />
              <SinglePageItemText 
                title="State"
                value={officerData.state}
              />
              <SinglePageItemText 
                title="ZIP Code"
                value={officerData.zip}
              />
            </div>
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>    
    </section>
  )
}

export default ContractingOfficerSingle;